import { call, put } from 'redux-saga/effects';
import { getBillingRetainers, saveBillingRetainerTerms, getRetainerStatus } from '../requests/billingRetainers';
import { showAlert } from '../../slices/alerts';
import { safeErrorMessage } from '../../../utils/errorUtils';

export function* handleGetBillingRetainers(action) {
    try {
        const { callback } = action.payload;
        const response = yield call(getBillingRetainers);
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (action.payload?.callback) {
            action.payload.callback(null);
        }
    }
}

export function* handleSaveBillingRetainerTerms(action) {
    try {
        const { entityType, entityId, billingTerms, callback } = action.payload;
        const response = yield call(saveBillingRetainerTerms, entityType, entityId, billingTerms);
        if (callback) callback({ ok: true, data: response.data });
    } catch (error) {
        const message = safeErrorMessage(error);
        yield put(showAlert({ severity: 'error', message }));
        if (action.payload?.callback) {
            action.payload.callback({ ok: false, message });
        }
    }
}

export function* handleGetRetainerStatus(action) {
    try {
        const { accountId, clientId, callback } = action.payload;
        const response = yield call(getRetainerStatus, { accountId, clientId });
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (action.payload?.callback) {
            action.payload.callback(null);
        }
    }
}
